 let gid = 0;


// 分配全局id
export const assignId = (pre) => {
  // 每次加一
  gid = gid + 1;
  return (pre || '') + gid;
}
